var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({class:[
    'btn-action-core justify-content-center align-items-center',
    _vm.variantClass,
  ],style:(_vm.customStyle),attrs:{"size":"sm","disabled":_vm.isDisable},on:{"click":_vm.handleClick}},'b-button',{ 'v-b-modal': _vm.modalTarget },false),[_c('div',{staticClass:"iconCore"},[(_vm.iconClass && _vm.isIconAfterText == false)?_c('i',{class:[_vm.iconClass, 'icon-btn-core me-2 icon-mobile-hide']}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.iconClass && _vm.isIconAfterText)?_c('i',{class:[_vm.iconClass, 'ms-2 icon-mobile-hide']}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }